import { orderStatus } from '@/constants';
import { getGlobalStore } from '@/lib/global-store';
import { MapStore } from '@/lib/map-control/model';
import mapMarkerList from '@/lib/map-control/mapMarkerList';
import shareDelaySecondController from '@/lib/map-control/share-delay-second/shareDelaySecondController';
import { allocationAlertActionType } from '@/vuex-store/allocation-alert/actions';
import { listControlActionType } from '@/vuex-store/list-control/actions';
import Order from '@/entity/Order';
const { state, dispatch, getters, } = getGlobalStore();
const { listControl, hubSelector, } = state;
// 목록관제 vuex 상태에 업데이트 하는 서비스 레이어 (CRUD)
// FLOW
// vue component (push handler) >> push methods >> push service >> vuex
export const orderPushService = {
    /**
     * vuex 주문 추가
     * @param param0
     */
    async addOrderToVuex(pushData) {
        return dispatch(listControlActionType.addOrder, pushData);
    },
    /**
     * vuex 주문 업데이트
     * @param pushData
     */
    async updateOrderToVuex(pushData) {
        return dispatch(listControlActionType.updateOrder, pushData);
    },
    /**
     * 기존 주문 데이터에 배차건 데이터 병합
     * @param pushData
     */
    mergeStatusAllocated(pushData) {
        Object.assign(pushData, {
            statusCode: orderStatus.ALLOCATED.code,
        });
        this.mergeOrder(pushData);
        // TODO 목록관제에서는 라이더 관련 사용 x
        // const {
        //   orderId,
        //   allocatedWorkerCode,
        // } = pushData;
        // const includedSelectedOrder = getters['listControl/includesSelectedItemList'](orderId);
        // const mkWorker = mapMarkerList.workers.getMarker(allocatedWorkerCode);
        // if (mkWorker && includedSelectedOrder) {
        //   mkWorker.updateRelatedWeight();
        //   mkWorker.updateMarker();
        // }
    },
    mergeStatusAccepted(pushData) {
        Object.assign(pushData, {
            statusCode: orderStatus.ACCEPTED.code,
            allocatedWorkerCode: '',
        });
        this.mergeOrder(pushData);
    },
    /**
     * 주문 데이터 병합 + 마커 추가 (도착지, 상점)
     * @param _pushData 푸시 데이터
     */
    async mergeOrder(_pushData) {
        const { dropLatitude, dropLongitude, pickupLatitude, pickupLongitude, 
        // storeId,
        orderId,
        // allocatedWorkerCode,
        // originStatusCode,
         } = _pushData;
        let orderData = listControl.orderList[orderId];
        // 도착지 좌표가 없는 경우 출발지 좌표 넣어주기
        const pushData = dropLatitude && dropLongitude
            ? _pushData
            : {
                ..._pushData,
                dropLatitude: pickupLatitude,
                dropLongitude: pickupLongitude,
            };
        // 선택한 상점의 주문일 경우 출력
        // const isSelectedStoreOrder = listControl.selectedStoreId
        //   && listControl.selectedStoreId === storeId;
        // 선택한 주문 존재 유무
        // const isSelectedOrder = listControl.selectedOrderItemsObj[orderId];
        // 선택한 라이더 코드
        // const selectedWorkerCode = getters['listControl/getterSelectedWorkerCode'];
        // 선택한 라이더의 주문일 경우
        // const isSelectedWorkerOrder = selectedWorkerCode
        //   && selectedWorkerCode === allocatedWorkerCode;
        // 배차 취소건 유무
        // const isAllocateCancel = originStatusCode === orderStatus.ALLOCATE_CANCEL.code;
        // 중요 :: vuex에 먼저 추가해야 함.
        // 기존 데이터 없으면 추가
        if (!orderData) {
            orderData = await this.addOrderToVuex(pushData);
        }
        else {
            orderData = await this.updateOrderToVuex(pushData);
        }
        // 중요 :: vuex에 먼저 추가하고 마커를 처리해야 함. 마커를 먼저 추가하면 주문을 찾을 수 없음
        // const mkDrop = mapMarkerList.addDropMarker(pushData);
        // 선택한 주문일 경우 >> 연관 라이더 추가 (선택한 주문이 접수에서 배차등으로 된 경우)
        // if (isSelectedOrder && !listControl.relatedWorkerList[allocatedWorkerCode]) {
        //   dispatch('listControl/addRelatedWorker', allocatedWorkerCode);
        // }
        // 선택한 라이더가 배차한 주문일 경우 선택한 라이더의 주문으로 추가
        // if (isSelectedWorkerOrder && !isAllocateCancel) {
        //   dispatch('listControl/addSelectedWorkerOrder', listControl.selectedWorker);
        //   mapMarkerList.updateOrderMarkerWeight(orderId);
        // }
        // 선택한 라이더가 배차한 주문이 배차취소된 경우
        // if (isSelectedWorkerOrder && isAllocateCancel) {
        //   mkDrop.unhighlight();
        //   mapMarkerList.updateOrderMarkerWeight(orderId, true, true);
        // }
        // 주문 추가시 선택되어 있어야 하는 경우 가중치 바로 추가
        // if (!orderData && (isSelectedStoreOrder || isSelectedWorkerOrder)) {
        //   mapMarkerList.updateOrderMarkerWeight(orderId, false, true);
        // }
        // mkDrop.highlight();
        // mkDrop.updateMarker();
        // const mkStore = mapMarkerList.stores.getMarker(storeId);
        // mkStore.updateMarker();
        return orderData;
    },
    /**
     * 상점 제거 처리 로직(vuex, map)
     * @param orderId
     * @param storeId
     */
    actionDeleteStore(orderId, storeId) {
        const store = listControl.storeList[storeId];
        const mkStore = mapMarkerList.stores.getMarker(storeId);
        // 상점에서 주문 제거
        store.deleteOrder(orderId);
        // 상점에 주문이 있을 경우
        if (store.hasItems) {
            store.delayedOrderIds.delete(orderId);
            if (store.delayedOrderIds.size === 0) {
                mkStore.updateMarker();
            }
        }
        // 상점에 주문 없을 경우
        if (!store.hasItems) {
            // 지도에서 상점 제거
            mkStore.deactivateMarker(true);
            dispatch('listControl/deleteStore', storeId);
            // 선택한 상점일 경우
            if (listControl.selectedStoreId === storeId) {
                dispatch('listControl/clearSelectedOrderItems');
                dispatch('listControl/setSelectedStoreId', null);
                listControl.selectedStoreId = null;
            }
        }
    },
    /**
     * 상점 추가
     * @param orderData
     */
    createStore(orderData) {
        const store = new MapStore(orderData);
        store.addOrder(orderData);
        dispatch('listControl/addStore', store);
        mapMarkerList.addStoreMarkers({
            [store.storeId]: store,
        });
        return store;
    },
    /**
     * 주문 제거
     */
    async deleteOrder(pushData) {
        const { 
        // storeId,
        orderId, allocatedWorkerCode: workerCode, } = pushData;
        const orderData = listControl.orderList[orderId];
        // const selectedWorkerCode = getters['listControl/getterSelectedWorkerCode'];
        const workerData = listControl.workerList[workerCode];
        // const mkWorker = mapMarkerList.workers.getMarker(workerCode);
        if (!orderData) {
            console.dir(`[deleteOrder] Not Exist Order. orderId: ${orderId}`);
            return;
        }
        if (workerData && workerData.isTemporallyOff) {
            dispatch('listControl/deleteWorkerOrder', {
                workerCode,
                orderId,
            });
            // 배차 0건이면 마커 제거
            if (workerData.isEmptyOrder()) {
                mapMarkerList.workers.deleteMarker(workerCode);
            }
        }
        // TODO 마커 제거
        // const mkDrop = mapMarkerList.drops.getMarker(orderId);
        // mkDrop.deactivateMarker(true);
        dispatch(listControlActionType.deleteOrder, orderId);
        // 현재 주문이 선택한 주문일 경우
        if (listControl.selectedOrderItemsObj[orderId]) {
            await dispatch('listControl/clearSelectedOrderItem', orderId);
        }
        // TODO 목록관제에서 사용 x
        // 연관 라이더 있을 경우 워커 마커 업데이트 (선택한 주문의 라이더)
        // if (
        //   listControl.relatedWorkerList[workerCode]
        //   && mkWorker
        // ) {
        //   mkWorker.updateMarker();
        //   await dispatch('listControl/clearRelatedWorker', workerCode);
        // }
        // 선택된 라이더의 주문일 경우 연관 주문에서 제거
        // if (workerCode === selectedWorkerCode) {
        //   await dispatch('listControl/clearSelectedWorkerOrder', workerCode);
        // }
        // this.actionDeleteStore(orderId, storeId);
    },
    /**
     * 주문 수정
     * @param pushData
     * @returns
     */
    async orderModify(pushData) {
        const { orderId,
        // payloadType,
         } = pushData;
        const orderData = listControl.orderList[orderId];
        // 주문 정보 변경건인데 기존에 주문이 없을 경우
        const isExist = orderData;
        if (!isExist) {
            const prevOrderData = shareDelaySecondController.get(orderId);
            if (!prevOrderData) {
                console.log('[orderModify] 주문 수정 이벤트인데 기존 데이터 없음. ui를 그릴 데이터 부족함.', pushData);
                return;
            }
            const { orderData: tempOrderData, } = prevOrderData;
            // orderModify는 데이터가 적기 때문에 기존 데이터와 병합해서 완성 시켜야 함.
            Object.assign(pushData, tempOrderData);
            const convertPushData = Order.convertPushData(tempOrderData);
            orderPushService.mergeOrder(convertPushData);
            return;
        }
        // statusCode 보정
        // eslint-disable-next-line no-param-reassign
        pushData.statusCode = orderData.statusCode;
        const convertPushData = Order.convertPushData(pushData);
        await dispatch(listControlActionType.modifyOrder, convertPushData);
        // TODO 마커 관련 제거
        // if (payloadType === socketPayloadType.DROP_INFO) {
        //   const mkDrop = mapMarkerList.drops.getMarker(orderId);
        //   mkDrop.updateDropPosition(convertPushData);
        // }
    },
    workerRequestedCancel(orderData) {
        orderPushService.mergeStatusAccepted(orderData);
        dispatch(allocationAlertActionType.print, [
            {
                title: 'reject_request_allocate',
                storeName: orderData.storeName,
                workerName: orderData.allocatedWorkerName,
                orderId: orderData.orderId,
            },
        ]);
    },
    async allocateCancel(pushData, _isShareOrder) {
        const { hubId, orderId, storeId, preStatusCode, statusCode, storeName, allocatedWorkerName, allocatedWorkerCode: workerCode, } = pushData;
        const subscribeKey = getters['hubSelector/getterIsSubscribeHub']
            ? 'allocatedHubId'
            : 'allocatedDistributorId';
        const selectedHubId = hubSelector.subscribeHubInfo[0].id;
        const isMyWorker = pushData[subscribeKey] === selectedHubId;
        const shareInfo = getters['hub/getAgencyShareInfo']({
            hubId,
            storeId,
        });
        // 목록관제에서는 배차 취소시 지도의 isHideShareOrder를 판단하지 않음
        // const {
        //   isHideShareOrder,
        // } = listControl.mapVisibilitySetting;
        const workerData = listControl.workerList[workerCode];
        // TODO 목록관제에는 마커 없음
        // const mkWorker = mapMarkerList.workers.getMarker(workerCode);
        // 공유건 배차 취소 -> shareDisplay N인 공유건 -> 삭제
        if (_isShareOrder
            && !shareInfo) {
            orderPushService.deleteOrder(pushData);
            return;
        }
        // 임시 퇴근일 경우 카운트 강제 감소
        if (workerData && workerData.isTemporallyOff) {
            dispatch('listControl/deleteWorkerOrder', {
                workerCode,
                orderId,
            });
            // 배차 0건이면 마커 제거
            if (workerData.isEmptyOrder()) {
                mapMarkerList.workers.deleteMarker(workerCode);
            }
        }
        // 배차 요청 거절 팝업
        // https://github.com/barogo/zoo/issues/2526
        if (preStatusCode === orderStatus.WORKER_REQUESTED.code
            && statusCode === orderStatus.ALLOCATE_CANCEL.code
            && isMyWorker) {
            dispatch(allocationAlertActionType.print, [
                {
                    title: 'reject_request_allocate',
                    storeName,
                    workerName: allocatedWorkerName,
                    orderId,
                },
            ]);
        }
        // 공유건, 공유숨김시, 선택된 상태일 때 선택 해제.
        // 배차취소는 접수건이며 접수건은 공유숨김에서 비노출 됨
        if (_isShareOrder
            // && isHideShareOrder
            && listControl.selectedOrderItemsObj[orderId]) {
            await dispatch('listControl/clearSelectedOrderItem', orderId);
        }
        // 배차 취소 전에 주문이 없을 수 있음.. 정상 주문 생성
        // 배차 취소일 경우 accepted로 변경
        // origin 값에 allocate_cancel 유무 추가
        const order = await orderPushService.mergeOrder({
            ...pushData,
            originStatusCode: orderStatus.ALLOCATE_CANCEL.code,
            statusCode: orderStatus.ACCEPTED.code,
        });
        // TODO 목록관제에서는 라이더 관련 사용 x
        // const mkDrop = mapMarkerList.drops.getMarker(orderId);
        // const mkStore = mapMarkerList.stores.getMarker(storeId);
        // mkDrop.updateMarker();
        // mkStore.updateMarker();
        // 연관 라이더 있을 경우 워커 마커 업데이트 (선택한 주문의 라이더)
        // if (
        //   listControl.relatedWorkerList[workerCode]
        //   && mkWorker
        // ) {
        //   mkWorker.updateRelatedWeight(true);
        //   mkWorker.updateMarker();
        //   dispatch('listControl/clearRelatedWorker', workerCode);
        // }
        // const { items } = getters['listControl/getterStoreList'][storeId];
        // const result = Object.values(items).some(({ statusCode: _statusCode }: any) => (
        //   isIncludedCurrentFilter(_statusCode, listControl.selectedOrderFilter)
        // ));
        // 상점 주문들이 모두 현 필터에 포함되지 않으면 상점, 주문 마커 숨김
        // if (!result) {
        // mkStore.deactivateMarker(false, true);
        // mkDrop.deactivateMarker();
        // dispatch('listControl/setSelectedStoreId', null);
        // dispatch('listControl/clearSelectedOrderItem', orderId);
        // }
        // 배차취소는 상태가 아닌 행위. 상태를 접수로 변경해야 함.
        order.changeToAccepted();
    },
    async pickUp(orderData) {
        const { orderId, allocatedWorkerCode,
        // storeId,
         } = orderData;
        await dispatch('listControl/updateOrder', orderData);
        const isNotPickupStatus = [
            orderStatus.ACCEPTED.code,
            orderStatus.ALLOCATED.code,
        ].includes(listControl.selectedOrderFilter);
        // 픽업 필터가 아닐 경우 로직 (제거 되어야 하는 필터시 로직)
        if (isNotPickupStatus && listControl.relatedWorkerList[allocatedWorkerCode]) {
            dispatch('listControl/clearRelatedWorker', allocatedWorkerCode);
        }
        // const mkDrop = mapMarkerList.drops.getMarker(orderId);
        if (isNotPickupStatus) {
            // mapMarkerList.updateOrderMarkerWeight(orderId, true);
            // mkDrop.deactivateMarker();
            return;
        }
        // 선택된 주문일 경우
        if (listControl.selectedOrderItemsObj[orderId]
            && !listControl.relatedWorkerList[allocatedWorkerCode]) {
            dispatch('listControl/addRelatedWorker', allocatedWorkerCode);
        }
        // mkDrop.updateMarker();
        // const mkStore = mapMarkerList.stores.getMarker(storeId);
        // mkStore.updateMarker();
    },
};
